export default "__VITE_ASSET__2mmA5MUW__"